import React, {PropTypes, Component} from 'react';

import SchedulingReports from '../SchedulingReports';

import {getBusinessReports,getTotalSchedulingReports, getRestrictionFilter} from '../selector';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions';

class BusinessReports extends Component {

  componentWillMount() {
    // pass current roleId. If not available the api fetches details of default role id
    const fetchParams = sessionStorage.getItem('roleId') ? {roleId: sessionStorage.getItem('roleId')} : {};
    this.props.actions.fetchReports(fetchParams);
  }

  render() {

    const {filteredReports, total, actions, restrictions} = this.props;

    return (
      <SchedulingReports
        exportReport={actions.exportReport}
        total={total}
        category="business"
        reports={filteredReports}
        restrictions={restrictions} />
    );
  }

}

BusinessReports.propTypes = {
  fetchingReports: PropTypes.bool,
  total: PropTypes.object,
  filteredReports: PropTypes.array,
  actions: PropTypes.object,
  restrictions: PropTypes.array,
};

const mapStateToProps = (state) => {
  const {fetchingReports} = state.reports;
  const { restrictions } = getRestrictionFilter(state);

  const filteredReports = getBusinessReports(state);
  const total = getTotalSchedulingReports(state);

  return {fetchingReports, filteredReports, total, restrictions};
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessReports);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/business-reports/BusinessReports.js